import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {RelationArticleGroup} from './relation-article-group';
import {ConfigUtil} from '@shared/services/config.util';

@Injectable({
  providedIn: 'root'
})
export class RelationArticleGroupApi {
  private readonly httpClient = inject(HttpClient);

  private endpoint: string;

  constructor() {
    this.endpoint = `${ConfigUtil.get('api')['backend']}/relationarticlegroups`;
  }

  public findAll(): Observable<RelationArticleGroup[]> {
    return this.httpClient.get<RelationArticleGroup[]>(`${this.endpoint}`);
  }

  public findById(id: number): Observable<RelationArticleGroup> {
    return this.httpClient.get<RelationArticleGroup>(`${this.endpoint}/${id}`).pipe(map(value => {
      return Object.assign(new RelationArticleGroup(), value);
    }));
  }

  public toggle(id: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.endpoint}/${id}/toggle`);
  }

  public save(relationArticleGroup: RelationArticleGroup): Observable<RelationArticleGroup> {
    return this.httpClient.post<RelationArticleGroup>(`${this.endpoint}`, relationArticleGroup).pipe(map(value => {
      return Object.assign(new RelationArticleGroup(), value);
    }));
  }

  public update(relationArticleGroup: RelationArticleGroup): Observable<boolean> {
    return this.httpClient.put<boolean>(`${this.endpoint}/${relationArticleGroup.id}`, relationArticleGroup);
  }

  public delete(id: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`${this.endpoint}/${id}`);
  }
}
